import { Injectable } from "@angular/core";
import { IJobNote, IJobNoteResponse, IJobNotesResponse } from "../interfaces/jobs-notes-response.interface";

import { BaseNotesService, type DateLike } from "@classes/notes.class";
import { JobsBillingCard } from "@app/views-interfaces/jobs-billing-card.interface";
import { getAnalyticsExtrasFromCard } from "../analytics-service";

@Injectable()
export class JobsAndBillingNoteService extends BaseNotesService<IJobNote> {
    protected dateField: keyof {
        [K in keyof IJobNote as IJobNote[K] extends DateLike ? K : never]: IJobNote[K];
    } = "date";

    protected async getNotes(id: string): Promise<IJobNote[]> {
        const result = await this.iframeMessagesService.postMessageResp("getJobsAndBillingNotes", { jobId: id }, "gotJobsNotes");
        if (result.status === "success") return (result.response as IJobNotesResponse)?.data.notes || [];
        throw new Error("Failed to fetch notes");
    }

    protected async addNote(id: string, text: string): Promise<IJobNote> {
        const result = await this.iframeMessagesService.postMessageResp("createJobsAndBillingNote", { jobId: id, note: text }, "jobNoteCreated");
        if (result.status === "success") {
            const note = (result.response as IJobNoteResponse)?.data?.notes?.[0];
            this.trackNoteAdded();
            return note;
        }
        throw new Error("Failed to add notes");
    }

    protected async deleteNote(id: string, noteId: string): Promise<{ success: boolean }> {
        const result = await this.iframeMessagesService.postMessageResp("deleteJobsAndBillingNote", { jobId: id, noteId }, "jobNoteDeleted");
        if (result.status === "success") return { success: true };
        throw new Error("Failed to delete notes");
    }

    protected sortNote(a: IJobNote, b: IJobNote): number {
        return new Date(b.date).getTime() - new Date(a.date).getTime();
    }

    private trackNoteAdded(): void {
        const card = this.cardModalService.currentCard() as JobsBillingCard;
        this.analyticsService.track("Add a Job note", getAnalyticsExtrasFromCard(card));
    }
}
